import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, apiError, fileUrl } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export default function UsersPanel() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/users").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const remove = async (u) => {
    if (!window.confirm(`Eliminare l'utente ${u.name} (${u.email}) e tutti i suoi contenuti? I pagamenti restano nello storico.`)) return;
    try { await api.delete(`/admin/users/${u.id}`); toast.success("Utente eliminato"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="users-panel" className="border border-neutral-200 rounded-2xl p-4">
      <h2 className="font-display font-bold mb-1">Utenti registrati {items && <span className="text-neutral-400 font-normal text-sm">({items.length})</span>}</h2>
      <p className="text-xs text-neutral-500 mb-3">Puoi eliminare singoli utenti con i loro post, offerte e commenti.</p>
      <div className="space-y-2">
        {(items || []).map((u) => (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="flex items-center gap-3 border border-neutral-100 rounded-xl px-3 py-2">
            <Avatar className="h-9 w-9"><AvatarImage src={fileUrl(u.avatar_url)} /><AvatarFallback className="bg-black text-white text-xs">{u.name?.[0]}</AvatarFallback></Avatar>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold truncate">{u.name}</p>
              <p className="text-xs text-neutral-500 truncate">{u.email} · {u.role}</p>
            </div>
            <button data-testid={`admin-delete-user-${u.id}`} onClick={() => remove(u)} className="p-2 text-neutral-300 hover:text-red-500"><Trash2 size={16} /></button>
          </div>
        ))}
        {items && items.length === 0 && <p data-testid="users-empty" className="text-xs text-neutral-400">Nessun utente registrato.</p>}
      </div>
    </div>
  );
}
